import type { FaireProductEntity } from "../../entity_types/product";

export const p_w5jyrw3xnf: FaireProductEntity = {
  token: "p_w5jyrw3xnf",
  type: "product",
  name: "Radiant cut full Eternity Moissanite Ring 925 Silver",
  brandToken: "b_mpb8yp79mh",
  brandName: "GEMPARA",
  imageUrl:
    "https://cdn.faire.com/fastly/7f3803787c12652b2ae83502d2f0ae10c894ccffcbf677206f90c6ffa93859db.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/31b4a365dffcbdc5eee028adde87804cfe3084ef4907e4f12e8616fab87b67ef.jpeg",
    "https://cdn.faire.com/fastly/f0293d8b85c4869254154d69b3f40913d2bbeb16d5207e452a48d1d198d73c03.jpeg",
  ],
  priceDollars: 138.55,
  description:
    "\nProduct Details\n\nMain Gemstone: 4.50 TCW Radiant cut  Moissanite\n\nTotal Stones : 21\n\nNet Weight : 5.23 grams\n\nA masterpiece of brilliance, this 4.50 TCW full eternity band is adorned with 21 radiant-cut lab-grown Moissanites, each meticulously set to form an unbroken circle of light. The 3.20 x 4.00mm Moissanites, boasting an exceptional E-F color and VVS-VS clarity, capture and reflect light with unparalleled fire and brilliance.\n\nDesigned with a 2.50mm thickness and 4.00mm band width, this ring offers a sleek yet bold presence, perfect for those who seek refined luxury. Whether worn as a wedding band, anniversary ring, or statement piece, this eternity band is a timeless symbol of love and elegance.\n",
  tags: [],
  msrpDollars: 277.11,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:59:27.532Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
